RECURRENCE_TYPES = ['new', 'active', 'returned', 'cold', 'dead']
# todo i18n
RECURRENCE_LABELS = ['Новые', 'Активные', 'Вернувшиеся', 'Остывшиe', 'Потерянные']
RECURRENCE_COLORS = ['#f15b19', '#f3a113', '#35ade8', '#a855a9', '#686DAD' ]
REAL_TIME_EVENTS = [
  'clientMessageCreated',
  'clientMessageUpdated'
]

{ STATUSES } = require 'models/order'

App.ClientsClientController = Em.Controller.extend
  realTime: Em.inject.service('realTime')
  notifier: Em.inject.service()
  VALIDATABLE_FIELDS: [
    'email',
    'blacklisted_comment'
  ]
  validations: {}

  env: Em.inject.service('environment')
  session: Em.inject.service('session')
  notifier: Em.inject.service()
  needs: ['clients']

  clientBinding: 'model'
  clientTagsBinding: 'controllers.clients.clientTags'

  organizations: Em.computed.alias('session.availableOrganizations')

  multipleOrganizations: Em.computed.gt('organizations.length', 1)

  promos: Ember.computed -> @store.find('promo')

  orders: []

  promosIssues:  Em.computed.filterBy 'promos', 'manual_issue_enabled', true

  currentTab: 'historyTab'
  isHistoryTab: Em.computed.equal('currentTab', 'historyTab')
  isBonusesTab: Em.computed.equal('currentTab', 'bonusesTab')
  isCommunicationsTab: Em.computed.equal('currentTab', 'communicationsTab')

  extendedBonusBlock: false
  substractBonuses: false
  bonusAmount: null
  activeBonusTransaction: false
  
  canEditBonusCanEditCardInBoard:  Em.computed.alias('session.currentOrganization.features.bonus_can_edit_card_in_board')

  init: ->
    REAL_TIME_EVENTS.forEach (event) =>
      handler = @[event]
      @get('realTime').on(event, @, handler) if handler


  clientMessageCreated: (data) ->
    @send('updateMessages', data) unless @get('clientMessages').find (msg) => msg.id is data.id


  clientMessageUpdated: (data) ->
    msg = @get('clientMessages').find (msg) => msg.id is data.client_message_id
    return unless msg
    Ember.set(msg, "is#{data.status.charAt(0).toUpperCase() + data.status.slice(1)}", true)
    if msg.incoming and msg.error_message
      Ember.set(msg, 'isFailed', true)
      Ember.set(msg, 'isDeleted', true)
    Em.setProperties(msg,
      {
        status: data.status
        error_message: data.error_message
      })


  showSegmentedControl: (->
    @get('isBonusesEnabled') or @get('env.features.communicationChannels')
  ).property('isBonusesEnabled', 'env.features.communicationChannels')

  isBonusesEnabled: (->
    isEnabled = false
    @get('session.availableOrganizations').forEach (o) ->
      isEnabled = !!o.get('bonus_enabled')
    isEnabled
  ).property('session.availableOrganizations')

  orderBlocksData: Em.A([])
  ordersProcessed: false
  selectedFilter: (->
    @get('orderFilters').get(0)
  ).property('orderFilters')

  orderFilters: (->
    [
      {
        all: true
        name: Em.I18n.t 'client_edit.history.all'
      },
      {
        processed: false, 
        name: Em.I18n.t 'client_edit.history.not_processed' 
      }, 
      {
        processed: true
        name: Em.I18n.t 'client_edit.history.processed'
      }
    ]
  ).property()

  # Инициализация orderBlocksData
  onOrdersChanged: (-> 
    data = @get('orders').map((order) => Em.Object.create({ order: order, isOpen: false }));
    needProcessFilter = @get('env.features.communicationChannels') and @get('env.features.clientRateToProcessed')
    unless needProcessFilter
      @set('orderBlocksData', Em.A(data))
    else 
      filteredData = Em.A(data.filter (item) => (item.order.get('client_rate_processed') is @get('selectedFilter.processed')) or @get('selectedFilter.all'))
      @set('orderBlocksData', filteredData)
  ).observes('orders', 'orders.@each.client_rate_processed', 'selectedFilter')

  # Вычислимые свойства
  avatarBackground: (->
    return unless @get('client.avatar')
    "background-image: url(#{@get('client.avatar')})".htmlSafe()
  ).property('client')

  regiseteredAt: (->
    moment(@get('client.registered_at')).format('D MMMM YYYY')
  ).property('client.registered_at')

  blacklistedAt: (->
    moment(@get('client.blacklisted_at')).format('D MMMM YYYY')
  ).property('client.blacklisted_at')

  clientRecurrenceType: (->
    @get('env').translate("clients.recurrence_label_long.#{@get('client.recurrence')}")
  ).property('client.recurrence')

  clientRecurrenceComment: (->
    @get('env').translate("clients.recurrence_comment.#{@get('client.recurrence')}")
  ).property('client.recurrence')

  extractValidations: (model, fields) ->
    errors = model.get('errors')
    validations = {}

    fields.forEach (field) =>
      if errors.has(field)
        validations[field] = errors.errorsFor(field).map (m) ->
          m.message
        .join(',')

    errors.clear()
    validations

  teardown: ->
    @set('validations', {})


  ###
  # Параметры графика возвращаемости клиента
  ###

  loadChartData: Ember.on('init', ->
    data = [
      name: 'returnedStatus'
      typeChart: 'line'
      keyFrom: 'dateFrom'
      keyTo: 'dateTo'
      data: [
        level: 1
        dateFrom: moment().subtract(6, 'months').toDate()
        dateTo: moment().subtract(5, 'months').toDate()
        label: "#{moment().subtract(6, 'months').format('D MMMM YYYY')} - #{moment().subtract(5, 'months').format('D MMMM YYYY')}"
      ,
        level: 0
        dateFrom: moment().subtract(5, 'months').toDate()
        dateTo: moment().subtract(3, 'months').toDate()
        label: "#{moment().subtract(5, 'months').format('D MMMM YYYY')} - #{moment().subtract(3, 'months').format('D MMMM YYYY')}"
      ,
        level: 1
        dateFrom: moment().subtract(3, 'months').toDate()
        dateTo: moment().subtract(2, 'months').toDate()
        label: "#{moment().subtract(3, 'months').format('D MMMM YYYY')} - #{moment().subtract(2, 'months').format('D MMMM YYYY')}"
      ,
        level: 2
        dateFrom: moment().subtract(2, 'months').toDate()
        dateTo: moment().subtract(1, 'months').toDate()
        label: "#{moment().subtract(2, 'months').format('D MMMM YYYY')} - #{moment().subtract(1, 'months').format('D MMMM YYYY')}"
      ,
        level: 3
        dateFrom: moment().subtract(1, 'months').toDate()
        dateTo: moment().toDate()
        label: "#{moment().subtract(1, 'months').format('D MMMM YYYY')} - #{moment().format('D MMMM YYYY')}"
      ]
    ,
      name: 'orders'
      typeChart: 'point'
      keyValue: 'created_at'
      data: [
        level: 1
        created_at: moment().subtract(24, 'week').toDate()
        # todo i18n
        label: "Заказ #{moment().subtract(24, 'months').format('D MMMM YYYY')}"
      ,
        level: 1
        created_at: moment().subtract(22, 'week').toDate()
        # todo i18n
        label: "Заказ #{moment().subtract(22, 'week').format('D MMMM YYYY')}"
      ,
        level: 0
        created_at: moment().subtract(19, 'week').toDate()
        # todo i18n
        label: "Заказ #{moment().subtract(19, 'week').format('D MMMM YYYY')}"
      ,
        level: 0
        created_at: moment().subtract(16, 'week').toDate()
        # todo i18n
        label: "Заказ #{moment().subtract(16, 'week').format('D MMMM YYYY')}"
      ,
        level: 1
        created_at: moment().subtract(10, 'week').toDate()
        # todo i18n
        label: "Заказ #{moment().subtract(10, 'week').format('D MMMM YYYY')}"
      ,
        level: 2
        created_at: moment().subtract(6, 'week').toDate()
        # todo i18n
        label: "Заказ #{moment().subtract(6, 'week').format('D MMMM YYYY')}"
      ,
        level: 3
        created_at: moment().subtract(2, 'week').toDate()
        # todo i18n
        label: "Заказ #{moment().subtract(2, 'week').format('D MMMM YYYY')}"
      ]
    ]

    Ember.run.later(@, ->
      @set('chartData', data)
    , 750)
  )

  chartRows: [
    level: 0
    color: RECURRENCE_COLORS[0]
    # todo i18n
    label: 'Aктивный'
  ,
    level: 1
    color: RECURRENCE_COLORS[1]
    # todo i18n
    label: 'Новый / Вернувшийся'
  ,
    level: 2
    color: RECURRENCE_COLORS[2]
    # todo i18n
    label: 'Остывший'
  ,
    level: 3
    color: RECURRENCE_COLORS[3]
    # todo i18n
    label: 'Мертвый'
  ]

  chartData: null

  bonusLogs: []
  clientMessages: []

  bonusMeta: 
    page: 1
    pageCount: 1
    perPage: 25

  messageMeta:
    page: 1
    pageCount: 1
    perPage: 25

  ordersMeta: 
    page: 1
    pageCount: 1
    perPage: 50

  isLoading: false
  processingRequests: 0
  unreadMessagesCount: null

  clientObserver: (->
    bonusMeta = 
      page: 1
      pageCount: 1
      perPage: 25

    messageMeta = 
      page: 1
      pageCount: 1
      perPage: 25

    ordersMeta = 
      page: 1
      pageCount: 1
      perPage: 50

    @setProperties({
      bonusMeta,
      messageMeta,
      ordersMeta,
      currentTab: 'historyTab'
    })
  ).observes('client').on('init')

  fetchBonusPortion: ->
    new Em.RSVP.Promise (resolve, reject) =>
      page         = @get('bonusMeta.page')
      perPage      = @get('bonusMeta.perPage')

      @set('isLoading', true)
      @set('processingRequests', @get('processingRequests') + 1)

      @get('client').nonRESTAction('GET', "bonus_log?page=#{page}&per_page=#{perPage}")
      .then (data) =>
        @set('processingRequests', @get('processingRequests') - 1)
        return unless data 
        meta = data.meta
        Object.assign @get('bonusMeta'), {
          page: meta.page
          pageCount: meta.page_count
        }


        resolve(data)
      .catch(reject)
      .finally =>
        @set('isLoading', false)

  loadBonusLogs: (->
    return unless @get('env.features.bonusEnabled')
    @set('bonusLogs', [])
    @fetchBonusPortion().then (data) =>
      @get('bonusLogs').pushObjects(data.bonus_log)
  ).observes('client')


  loadMoreBonusLogs: (->
    return if Ember.isEmpty(@get('loadBonusLogs'))
    return if @get('isLoading')
    return if @get('bonusMeta.page') >= @get('bonusMeta.pageCount')
    @incrementProperty('bonusMeta.page')
    @fetchBonusPortion().then (data) =>
      @get('bonusLogs').pushObjects(data.bonus_log)
  )

  fetchMessagesPortion: ->
    new Em.RSVP.Promise (resolve, reject) =>
      page         = @get('messageMeta.page')
      perPage      = @get('messageMeta.perPage')

      @set('isLoading', true)
      @set('processingRequests', @get('processingRequests') + 1)

      @get('client').nonRESTAction('GET', "client_messages?page=#{page}&per_page=#{perPage}")
      .then (messages) =>
        @set('processingRequests', @get('processingRequests') - 1)

        meta = messages.meta
        Object.assign @get('messageMeta'), {
          page: meta.page
          pageCount: meta.page_count
        }
        resolve(messages)
      .catch(reject)
      .finally =>
        @set('isLoading', false)


  fetchOrdersPortion: ->
    new Em.RSVP.Promise (resolve, reject) =>
      page         = @get('ordersMeta.page')
      perPage      = @get('ordersMeta.perPage')

      @set('isLoading', true)
      @set('processingRequests', @get('processingRequests') + 1)

      filters = {
        client_id: @get('client.id')
        status: _.without(STATUSES, 'draft')
        sort:   'created_at DESC'
        page: page
        perPage: perPage
      }   

      @store.find('order', filters)
      .then (data) =>
        @set('processingRequests', @get('processingRequests') - 1)

        meta = data.meta
        Object.assign @get('ordersMeta'), {
          page: meta.page
          pageCount: meta.page_count
        }
        resolve(data)
      .catch(reject)
      .finally =>
        @set('isLoading', false)


  loadMessages: (->
    return unless @get('env.features.communicationChannels')
    @set('clientMessages', [])
    @fetchMessagesPortion().then (data) =>
      @set('unreadMessagesCount', data.meta.unread_messages_count)
      @get('clientMessages').pushObjects(data.client_messages)
  ).observes('client')
  

  loadOrders: (->
    @set('orders', [])
    @fetchOrdersPortion().then (data) =>
      @get('orders').pushObjects(data.content)
  ).observes('client')

  loadMoreOrders: (->
    return if Ember.isEmpty(@get('loadOrders'))
    return if @get('isLoading')
    return if @get('ordersMeta.page') >= @get('ordersMeta.pageCount')
    @incrementProperty('ordersMeta.page')
    @fetchOrdersPortion().then (data) =>
      @get('orders').pushObjects(data.content)
  )

  getRawText: (text) ->
    regex = /(http|https|ftp|file):\/\/[^\s"')]+(?=\s|$|\b)(?<![.,!?])(?=\b)(?=\S*(?:[.,!?]|$))/g
    raw = text.replace regex, (url) ->
      "<a href='#{url}'>#{url}</a>"
    raw.replace(/\n/g, "<br>")



  mappedMessages: (-> 
    messages = @get('clientMessages')
    return [] unless messages

    sortedMessages = messages.sortBy('created_at')
    sortedMessages.forEach (message) =>
      contentType = message.content_type
      status = message.status

      if message.text and not message.replaced
        Ember.set(message, 'replaced', true)
        Ember.set(message, 'text', @getRawText(message.text))

      if message.incoming and message.error_message
        Ember.set(message, 'isFailed', true)
        Ember.set(message, 'isDeleted', true)
      Ember.set(message, "is#{ contentType.charAt(0).toUpperCase() + contentType.slice(1)}", true)

      Ember.set(message, 'time', moment(message.created_at).format('LT'))
      Ember.set(message, "is#{status.charAt(0).toUpperCase() + status.slice(1)}", true)

    # Group sorted messages by date
    @groupMessagesByDate(sortedMessages)
  ).property('clientMessages.@each')


  loadMoreMessages: (->
    return if Ember.isEmpty(@get('loadMessages'))
    return if @get('isLoading')
    return if @get('messageMeta.page') >= @get('messageMeta.pageCount')
    @incrementProperty('messageMeta.page')
    @fetchMessagesPortion().then (data) =>
      @set('unreadMessagesCount', data.meta.unread_messages_count)
      @get('clientMessages').unshiftObjects(data.client_messages)
      if Em.$('.messages-chat').scrollTop() is 0
        Em.$('.messages-chat').scrollTop(200)
  )

  groupMessagesByDate: (messages) ->
    messages.reduce ((groups, message) ->
      date = new Date(message.created_at).toLocaleDateString('ru-RU') # Преобразуем дату в локальный формат
      group = groups.find (g) -> g.date == date

      unless group
        group = { date: date, messages: [] }
        groups.push(group)

      group.messages.push(message)
      groups
    ), []


  ###
  # События
  ###
  actions:
    createNewOrder: ->
      client_id = @get('client.id')
      @transitionToRoute('orders.create', queryParams: { client_id })

      false

    createOrderWithinOrganization: (organization)->
      client_id = @get('client.id')
      @transitionToRoute('orders.create', queryParams: { client_id, organization_id: organization.id })

      false

    issuePromo: (promo, button) ->
      return unless confirm("Выдать промокод к акции «#{promo.get('name')}»?")
      button.set 'isLoading', true
      promo.issue(@get('client.id'))
        .then =>
          # todo i18n
          @get('notifier').pushNotification
            type:     'success'
            title:    'Готово'
            message:  'Промокод к акции отправлен клиенту.'
        .catch =>
          # todo i18n
          @get('notifier').pushNotification
            type:     'error'
            title:    'Ошибка'
            message: 'Не удалось создать или отправить промокод клиенту.'
        .finally =>
          button.set 'isLoading', false

    acceptChanges: ->
      @set('isSaving', true)
      client = @get('client')
      client.save()
      .then =>
        @transitionToRoute('clients')
      .catch =>
        false
      .finally =>
        @set('validations', @extractValidations(client, @VALIDATABLE_FIELDS))
        @set('isSaving', false)
      false

    delete: ->
      # todo i18n
      if confirm 'Удалить клиента?'
        client = @get('client')

        client.destroyRecord()
        .then =>
          @controllerFor('clients')?.get('clients')?.removeObject(client)
          @transitionToRoute('clients')
      false

    discardChanges: ->
      @get('client').rollback()
      @get('client.client_tags').clear()
      @get('initialClientTags').forEach (tag) =>
        @get('client.client_tags').pushObject(tag)
      @transitionToRoute('clients')
      false

    toggleOrderBlock: (orderId) ->
      @get('orderBlocksData').forEach (obj) => if obj.order.get('id') != orderId then obj.set('isOpen', false)
      dataItem = @get('orderBlocksData').find((obj) => obj.order.get('id') == orderId)
      dataItem.toggleProperty('isOpen')
      false

    # ClientTag actions
    onRemoveClientTag: (clientTag) ->
      @get('client.client_tags').removeObject(clientTag)

    onAddClientTag: (clientTag) ->
      @get('client.client_tags').addObject(clientTag)

    onAddAndCreateTag: (tagName) ->
      tag = @store.createRecord 'client_tag',
        name: tagName
        organization: @get('session.currentOrganization')
      tag.save()
      @get('client.client_tags').addObject(tag)

    toggleBonusBlock: ->
      @toggleProperty('extendedBonusBlock')
      false

    changeBonusAmount: ->
      amount = Math.abs(parseInt(@get('bonusAmount')))
      return unless amount
      return unless confirm("#{Em.I18n.t 'client_edit.form.bonuses.confirm_transaction'}")

      @set('activeBonusTransaction', true)
      amount = -amount if @get('substractBonuses')
      client = @get('client')
      client.nonRESTAction('PUT', 'commit_bonus_amount', {amount: amount})
      .then =>
        @set('bonusAmount', null)
        client.reload()
        @loadBonusLogs()
      .finally =>
        @set('activeBonusTransaction', false)

    loadMoreBonuses: ->
      @loadMoreBonusLogs()
      false
    
    loadMoreClientMessages: ->
      @loadMoreMessages()
      false

    loadMoreOrders: ->
      @loadMoreOrders()
      false

    updateMessages: (message) ->
      @get('clientMessages').pushObject(message)
      Em.run.next =>
        Em.$('.messages-chat').scrollTop(Em.$('.messages-chat').prop('scrollHeight') + 1000)
      false

    readAllMessages: ->
      console.log 'here'
      @set('unreadMessagesCount', null)
      false
      
    fieldNameChanged: ->
      clientName = @get('client.name')
      formattedName = clientName && clientName.charAt(0).toUpperCase() + clientName.slice(1)
      @set('client.name', formattedName)
      false

    reloadOrdersWithFilter: (data) ->
      @set('selectedFilter', data)
      filters = {
        client_id: @get('client.id')
        status: _.without(STATUSES, 'draft')
        sort:   'created_at DESC'
      }   
      unless data.all
        filters.client_rate_processed = data.processed
      @store.find('order',  filters).then (data) =>
        @set('orders', data)
